import { useCallback } from 'react';

/**
 * Hook for transforming step names
 *
 * - Converts title case to sentence case (e.g., "Personal Details" -> "Personal details")
 * - Changes "Payment" to "Payment method"
 */
const useStepNameTransformer = () => {
  const transformStepName = useCallback((stepName: string): string => {
    if (stepName === 'Payment') {
      return 'Payment method';
    }

    return stepName.charAt(0).toUpperCase() + stepName.slice(1).toLowerCase();
  }, []);

  return {
    transformStepName
  };
};

export default useStepNameTransformer;
